
import Page from '../Page';
import withRouterParams from '../../withRouterParams';
import { Button } from '@mui/material';
import { hideLoading, showLoading } from '../../loading';
import request from '../../request';
import swal from 'sweetalert';
import CenteredMessage from '../../components/CenteredMessage';
import EntityInfo from '../Dashboard/EntityInfo';
import LabeledContainerProduct from '../Dashboard/LabeledContainerProduct';
import LabeledContainer from '../../components/LabeledContainer';
import LoanDetails from '../../components/LoanDetails';
import AttachmentList from '../../components/AttachmentList';
import PillLabel from '../../components/PillLabel';
import LoanPaymentsTable from '../../components/LoanPaymentsTable';
import RoundedIconButton from '../../components/RoundedIconButton';
import { Refresh } from '@mui/icons-material';
import PaymentDialog from './PaymentDialog';

class _Loan extends Page {

   state = {
      loan: null,
      paymentDialogOpen: false
   }

   openPaymentDialog = () => {
      this.setState({ paymentDialogOpen: true });
   }

   closePaymentDialog = async (amount) => {

      if (amount) {
         try {

            // get payment link
            showLoading();

            const res = await request.post(`/api/customer/loans/${this.getLoanId()}/payments`, { amount });
            const url = res.data.payment_link;

            // redirect to payment link
            window.location.href = url;

         } catch (err) {
            swal('Error', err.message, 'error');
            return;
         } finally {
            hideLoading();
         }
      }

      this.setState({ paymentDialogOpen: false });

   }


   getLoanId() {
      return this.props.params.id;
   }

   fetch = async () => {
      try {
         
         showLoading();

         const loanId = this.getLoanId();
         const res = await request.get(`/api/customer/loans/${loanId}`);

         this.setState({ loan: res.data });

      } catch (err) {
         swal('Error', err.message, 'error');
      } finally {
         hideLoading();
      }
   }

   getDefaultPaymentAmount() {
      // TODO: refactor this so that it uses the same logic
      // as in dashboard loans to avoid code duplication
      const payments = this.state.loan.payments.filter(p => !p.paid);
      return payments[0]?.amount;
   }

   componentDidMount() {
      super.componentDidMount();
      this.fetch();
   }

   _render() {

      let jsx;

      if (this.state.loan) {

         const { customer, product, status, loan_no, principal, tenure, annual_rate, owing, deposit, attachments, payments } = this.state.loan;
 
         jsx = <div className='grid grid-rows-[auto,1fr] h-full'>
            
            <div className='grid grid-cols-[1fr,auto] p-4 border-b'>
               <h1 className='text-xl md:text-4xl font-bold'>
                  Loan <span className='text-gray-500'>
                     #{loan_no}
                  </span>
               </h1>
               <div className='flex items-center'>
                  <PillLabel className='uppercase' color='secondary'>
                     {status}
                  </PillLabel>
               </div>
            </div>

            <div className='px-4 sm:px-8 lg:px-24 py-8 overflow-y-auto'>
               
               <div className='grid grid-cols-1 md:grid-cols-2 gap-8'>
                  <EntityInfo
                     info={customer}
                  />

                  <LabeledContainerProduct product={product} />

                  <LoanDetails
                     principal={principal}
                     annual_rate={annual_rate}
                     tenure={tenure}
                     owing={owing}
                     deposit={deposit}
                  />

                  <LabeledContainer label='Attachments' className='rounded-lg p-4'>
                     <AttachmentList variant='grid' attachments={attachments} />
                  </LabeledContainer>

                  {
                     payments.length > 0 && <div className="col-span-full">
                        <LoanPaymentsTable payments={payments} />
                     </div>
                  }
               </div>

            </div>
         </div>

      } else {
         jsx = <CenteredMessage
            message='Failed to load'
            onRefresh={this.fetch}
         />
      }

      return <div className='page-height text-gray-600 overflow-y-hidden relative'>
         <div className='overflow-y-hidden h-full'>
            {jsx}
         </div>
         <div className='text-right p-2 absolute bottom-0 right-0'>
            <RoundedIconButton onClick={this.fetch} color='secondary'>
               <Refresh />
            </RoundedIconButton>
            <Button
               variant='contained'
               onClick={this.openPaymentDialog}
               className='px-4 rounded-full ml-2'
               size='small'
            >
               PAY
            </Button>
         </div>
         {
            this.state.paymentDialogOpen && <PaymentDialog
               onClose={this.closePaymentDialog}
               defaultAmount={this.getDefaultPaymentAmount()}
            />
         }
      </div>
   }

}


const Loan = withRouterParams(_Loan);
export default Loan;